import { toDate } from 'utils/converters';

const formatBeneficio = (dados) => {
  const { dataEntrada, perda, quantidadeTotal, switchAvulso } = dados.dados;

  const newData = {
    avulso: switchAvulso ? 1 : 0,
    dataEntrada: toDate(dataEntrada),
    escolha: dados?.escolha?.quantidadeEscolha && [
      {
        descricao: dados?.escolha?.qualidadeEscolha?.descricao,
        qualidade: dados?.escolha?.qualidadeEscolha?.id,
        quantidade: dados?.escolha?.quantidadeEscolha,
      },
    ],
    adicionais: dados.informacoesAdicionais
      ?.filter((item) => !!item)
      ?.map((item) => ({
        id: item.id,
        descricao: item.descricao,
        tipo: item.informacao?.descricao,
        resultado: item.resultado || '',
      })),
    lotes:
      !switchAvulso && dados?.escolherLotes?.length > 0
        ? dados.escolherLotes?.map((item) => ({
            id: item.idLote || item.id,
            codigo: item.codigo,
            quantidade: Number(item.quantidade),
            ref_id: item.idLote || item.id,
          }))
        : [],
  };

  const { tipo: _tipoOmitido, medida: _medidaOmitido, medidaTara: _medidaTaraOmitido, ...restDados } = dados.dados || {};
  const { bagLinhas: bagLinhasRaw } = restDados;
  const codigoFromLine = (l) => {
    const c = l.codigo ?? l.code;
    const n = Number(c);
    if (typeof c === 'number' && !Number.isNaN(c)) return c;
    if (!Number.isNaN(n) && n >= 1 && n <= 100) return n;
    return null;
  };
  const bagLinhas = (bagLinhasRaw || [])
    .filter((l) => codigoFromLine(l) != null)
    .map((l) => ({
      codigo: codigoFromLine(l),
      quantidade: Number(l.quantidade) || 0,
      observacao: l.observacao ?? null,
    }));

  const dadosProcessados = {
    ...restDados,
    qualidade: restDados.qualidade?.id ?? 0,
    quantidade: Number(quantidadeTotal || 0),
    perda: perda || 0,
    bagLinhas,
  };

  const tempData = { ...newData, ...dadosProcessados };
  // Garantir dataEntrada sempre no formato YYYY-MM-DD (não sobrescrever com o Date do form).
  tempData.dataEntrada = toDate(dataEntrada);
  return tempData;
};

export { formatBeneficio };
